// extracted by mini-css-extract-plugin
module.exports = {"applicationForm":"ApplicationNoteForm_applicationForm__2yUKy","submitButton":"ApplicationNoteForm_submitButton__N42Ck"};